module.exports = __webpack_public_path__ + "img/www_pack.e7e4b28b.png";